;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'clsx';
// import { BLOCKS } from '@contentful/rich-text-types';
// import Text from 'components/ui/Text';
import PropTypes from 'prop-types';

import RichText from 'components/ui/RichText';

import styles from './Award.module.scss';

const Award = ({ richText, isDark }) => {
    if (!richText) {
        return null;
    }

    return (
        <div
            className={cx(styles.root, {
                [styles.isDark]: isDark,
            })}
        >
            <div className={styles.awardRichText}>
                <RichText richText={richText} />
            </div>
        </div>
    );
};

Award.propTypes = {
    richText: PropTypes.object,
    isDark: PropTypes.bool,
};

export default Award;
